var map = {
	"./assiopay_logo.png": "cb82",
	"./circuits/amex.png": "b48d",
	"./circuits/android-pay.png": "3e66",
	"./circuits/apple-pay.png": "8fc3",
	"./circuits/bitcoin.png": "4616",
	"./circuits/diners-club.png": "47e3",
	"./circuits/discover.png": "0057",
	"./circuits/etherum.png": "2cae",
	"./circuits/jcb.png": "dd8f",
	"./circuits/maestro.png": "8226",
	"./circuits/mastercard.png": "d5aa",
	"./circuits/monero.png": "f48e",
	"./circuits/paypal.png": "f2d2",
	"./circuits/postepay.png": "65ef",
	"./circuits/tether.png": "74d7",
	"./circuits/unionpay.png": "5098",
	"./circuits/visa.png": "b69b",
	"./nexi_logo.png": "04bd",
	"./paypal_logo.png": "d2e6",
	"./satispay_logo.png": "f56d",
	"./vendon/vendon_logo_0.png": "24db",
	"./vendon/vendon_logo_1.png": "9a29",
	"./vendon_logo.png": "ef54"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "13a6";